/**
 * Product stats — contador animado + barra de progresso.
 *
 * O HTML nasce com o valor FINAL (número e width da barra): sem JS, crawler,
 * screenshot e reduced-motion mostram o dado oficial. A animação é só uma
 * melhoria visual: quando a seção se aproxima da viewport (IO), o JS zera a
 * camada visual (aria-hidden) e conta até o alvo — uma única vez.
 */
document.addEventListener('DOMContentLoaded', function () {
  var reduce =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce) return; // valores finais já estão no HTML — nada a animar

  document.querySelectorAll('.product-stats').forEach(function (section) {
    var percents = section.querySelectorAll('[data-pst-percent]');
    var bars = section.querySelectorAll('[data-pst-bar]');
    if (!percents.length) return;

    var targets = Array.prototype.map.call(percents, function (el, i) {
      return {
        el: el,
        bar: bars[i] || null,
        target: parseInt(el.dataset.target, 10) || 0,
        current: 0,
      };
    });

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect(); // anima no máximo uma vez

          // zera a camada visual só agora, imediatamente antes de contar —
          // até aqui o usuário (e qualquer render estático) via o valor final
          targets.forEach(function (t) {
            t.el.textContent = '0';
            if (t.bar) {
              t.bar.style.transition = 'none';
              t.bar.style.width = '0%';
            }
          });

          var maxValue = Math.max.apply(
            null,
            targets.map(function (t) {
              return t.target;
            })
          );
          var duration = 2000;
          var tickInterval = maxValue > 0 ? Math.floor(duration / maxValue) : duration;

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              targets.forEach(function (t) {
                if (t.bar) {
                  t.bar.style.transition = 'width ' + duration + 'ms linear';
                  t.bar.style.width = t.target + '%';
                }
              });
            });
          });

          var interval = setInterval(function () {
            var allDone = true;
            targets.forEach(function (t) {
              if (t.current < t.target) {
                t.current++;
                t.el.textContent = t.current;
                allDone = false;
              }
            });
            if (allDone) clearInterval(interval);
          }, tickInterval);
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);
  });
});
